import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import Input from '../Inputs/Input/Input';
import Button from '../Button/Button';
import { colors } from '../../constants/colors';

/**
 * Компактная модалка «название новой записи справочника»: открывается кнопкой в
 * конце списка селекта, чтобы менеджер сначала посмотрел, есть ли нужное
 * значение, и только потом добавлял своё — не уходя с экрана.
 */
const DictionaryNameModal = ({ isOpen, onClose, title, fieldLabel, placeholder, context, saving, onSubmit }) => {
  const [name, setName] = useState('');

  // Модалка не размонтируется между открытиями — чистим поле сами, иначе в ней
  // остаётся название от прошлого раза.
  useEffect(() => {
    if (isOpen) setName('');
  }, [isOpen]);

  const submit = () => {
    if (saving || !name.trim()) return;
    onSubmit(name);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} title={title} width="480px" contentStyle={{ top: '18%', bottom: 'auto' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {context && (
          <div style={{ fontFamily: "'Exo 2', sans-serif", fontSize: 13, color: colors.cameo }}>{context}</div>
        )}
        <Input
          label={fieldLabel}
          placeholder={placeholder}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          required
          autoFocus
        />
        <Button text="Добавить" fill onClick={submit} disabled={saving || !name.trim()} />
      </div>
    </Modal>
  );
};

export default DictionaryNameModal;
